module.exports = __webpack_public_path__ + "img/art6.355458fe.jpg";